import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import Row from './Row';
import Column from './Column';

const Grid = ({ children, className, fluid }) => {
  const classes = cns(
    fluid ? 'container-fluid' : 'container',
    className,
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

Grid.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se si vuole avere un contenitore fluido
     * che si espande alla grandezza del suo parent */
  fluid: PropTypes.bool,
};

Grid.defaultProps = {
  children: null,
  className: '',
  fluid: false,
};

Grid.Col = Column;
Grid.Row = Row;

export default Grid;
